export const studentTableHeader = [
  {
    field: 'slNo',
    headerName: 'SL.NO',
    width: 90,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'student_name',
    headerName: 'Name',
    width: 180,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'admn_no',
    headerName: 'Adm No',
    width: 140,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'student_mob_no',
    headerName: 'Phone No',
    width: 160,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'course_name',
    headerName: 'Course',
    width: 200,
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'classTaken',
    headerName: 'Class Taken',
    width: 140,
    headerAlign: 'left',
    align: 'left',
  },
];
